module.exports = __webpack_public_path__ + "media/music/jazzy_bass_0-70d0342f.mp3";